import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

function Settings() {
    return (
        <Box>
            <Typography className="app-page-title" sx={{ fontSize: 30, fontWeight: 700, color: '#202124', mb: 3 }}>
                Settings
            </Typography>
            <Paper
                elevation={0}
                sx={{
                    p: 4,
                    borderRadius: 4,
                    border: '1px solid #E7ECF2',
                    backgroundColor: '#FFFFFF',
                }}
            >
                <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#202124', mb: 1 }}>
                    Settings module
                </Typography>
                <Typography sx={{ color: '#6B7280', maxWidth: 720 }}>
                    This placeholder keeps the redesigned sidebar aligned with the provided navigation structure.
                </Typography>
            </Paper>
        </Box>
    );
}

export default Settings;
